import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * @file index.tsx
 * @author markJia(markjia@tencent.com)
 */
import { useUncontrolled, useRefGetter, useRefCallback } from '@tencent/glue-react-use';
import React, { useLayoutEffect, useRef, useState } from 'react';
import { withViewComponent } from '../../hoc/withViewComponent';
import { useCreateTabs, TabsContext } from '@tencent/glue-react-tabs';
export var NO_INITIAL_VALUE = 'no_init_value';

var getPosition = function getPosition(el, value, ids) {
  var children = _toConsumableArray(el.children);

  var idx = ids.indexOf(value);

  if (idx === -1) {
    return {
      left: 0,
      width: 0
    };
  }

  var _el$getBoundingClient = el.getBoundingClientRect(),
      parentLeft = _el$getBoundingClient.left;

  var _children$idx$getBoun = children[idx].getBoundingClientRect(),
      left = _children$idx$getBoun.left,
      itemWidth = _children$idx$getBoun.width;

  return {
    left: left - parentLeft,
    width: itemWidth
  };
};

export var ViewTabs = withViewComponent(function ($p, $s, $c, $a) {
  var _$c2;

  var _$p$closable = $p.closable,
      closable = _$p$closable === void 0 ? false : _$p$closable,
      _$p$className = $p.className,
      className = _$p$className === void 0 ? '' : _$p$className,
      _$p$disabled = $p.disabled,
      disabled = _$p$disabled === void 0 ? false : _$p$disabled,
      value = $p.value,
      defaultValue = $p.defaultValue,
      onValueChange = $p.onValueChange,
      children = $p.children,
      _$p$headerBorder = $p.headerBorder,
      headerBorder = _$p$headerBorder === void 0 ? true : _$p$headerBorder,
      _$p$headerClassName = $p.headerClassName,
      headerClassName = _$p$headerClassName === void 0 ? '' : _$p$headerClassName,
      headerStyle = $p.headerStyle,
      _$p$headerItemSpacing = $p.headerItemSpacing,
      headerItemSpacing = _$p$headerItemSpacing === void 0 ? 32 : _$p$headerItemSpacing,
      _$p$contentClassName = $p.contentClassName,
      contentClassName = _$p$contentClassName === void 0 ? '' : _$p$contentClassName,
      contentStyle = $p.contentStyle,
      _$p$size = $p.size,
      size = _$p$size === void 0 ? 'md' : _$p$size,
      _$p$type = $p.type,
      type = _$p$type === void 0 ? 'default' : _$p$type;
  var ref = useRef(null);

  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      activeStyle = _useState2[0],
      setActiveStyle = _useState2[1];

  var _useUncontrolled = useUncontrolled(!!value, NO_INITIAL_VALUE, value, defaultValue, onValueChange, 'value'),
      _useUncontrolled2 = _slicedToArray(_useUncontrolled, 2),
      val = _useUncontrolled2[0],
      onChange = _useUncontrolled2[1];

  var tabs = useCreateTabs({
    closable: closable,
    disabled: disabled,
    value: val,
    onValueChange: onChange
  });
  var tabItems = tabs.getTabItemList();
  var getTabItems = useRefGetter(tabItems);
  var updateTabItems = useRefCallback(function () {
    if (val === NO_INITIAL_VALUE) {
      tabItems[0] && onChange(tabItems[0].getId());
    }

    if (!ref.current) {
      return;
    }

    var items = getTabItems();

    var _getPosition = getPosition(ref.current, val, items.map(function (item) {
      return item.getId();
    })),
        left = _getPosition.left,
        width = _getPosition.width;

    setActiveStyle({
      left: left,
      width: width
    });
  });
  useLayoutEffect(function () {
    updateTabItems();
  }, [val, tabItems, headerStyle]);
  var itemsHeader = tabItems.map(function (item, idx) {
    return React.createElement("div", {
      key: String(item.getId()),
      onClick: function onClick() {
        return item.onActiveChange(item.getId());
      },
      className: $c('header-item', {
        active: item.getId() === val
      }),
      style: {
        marginLeft: idx === 0 ? 0 : headerItemSpacing
      }
    }, item.getTitle());
  });
  return React.createElement(TabsContext.Provider, {
    value: tabs
  }, React.createElement("div", _objectSpread({
    className: $c(true, _defineProperty({}, type, true), false, className),
    style: $s
  }, $a), React.createElement("div", {
    className: $c('header', (_$c2 = {
      closable: closable
    }, _defineProperty(_$c2, size || '', true), _defineProperty(_$c2, "border", headerBorder), _defineProperty(_$c2, type, true), _$c2), false, headerClassName),
    style: headerStyle,
    ref: ref
  }, itemsHeader, type !== 'card' && React.createElement("span", {
    className: $c('header-active-line'),
    style: activeStyle
  })), React.createElement("div", {
    className: $c('content', undefined, false, contentClassName),
    style: contentStyle
  }, children)));
}, 'tabs', ['type', 'closable', 'disabled', 'className', 'defaultValue', 'value', 'headerBorder', 'headerItemSpacing', 'headerClassName', 'headerStyle', 'onValueChange', 'children', 'size', 'contentClassName', 'contentStyle']);